import FieldReferenceDto from "../datastructuremodule/FieldReferenceDto";

export default class TableFormDto {

    constructor(name: string | null, fields: FieldReferenceDto[]) {
        this.Name = name;
        this.Fields = fields;
    }

    Name: string | null;
    Fields: FieldReferenceDto[];
}